import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { i as isHorizontalFlipOnRTL } from '../utils/isHorizontalFlipOnRTL-7yAAaYS8.js';
import { u as useGetIcon } from '../utils/useGetIcon-BfA5jgaY.js';
import { r as renderIconSVG } from '../utils/renderIconSVG-fObqPj4k.js';
import { I as IconClassWrapper, a as IconWrapperStyled } from '../Icon.styles-BxPGBwBy.js';
import { E as ErrorBoundary } from './ErrorBoundary-CVwzVg0z.js';

const farIcons = new Set(['lightbulb', 'calendar', 'clock', 'text-separator', 'house', 'star']);
const RemoteIcon = ({
  type,
  size,
  fontSize,
  transform,
  isClickTarget = false,
  color,
  'data-testid': dataTestId,
  ...rest
}) => {
  const prefix = farIcons.has(type) ? 'far' : 'fas';
  const [iconName, horizontalFlipOnRTL] = isHorizontalFlipOnRTL(type);
  const icon = useGetIcon(prefix, iconName);
  return /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(IconClassWrapper, {
    $spin: iconName === 'spinner',
    $size: size,
    $fontSize: fontSize,
    $color: color
  }, className => /*#__PURE__*/React__default.createElement(IconWrapperStyled, _extends({}, rest, {
    $isClickTarget: isClickTarget,
    $fontSize: fontSize,
    $horizontalFlipOnRTL: horizontalFlipOnRTL,
    dangerouslySetInnerHTML: {
      __html: renderIconSVG(icon, transform, className)
    },
    "data-testid": dataTestId || `storm-ui-icon-${iconName}`
  }))));
};

export { RemoteIcon as R };
//# sourceMappingURL=RemoteIcon-CAUbEduC.js.map
